<section id="home" class="hero">
  <!-- Hero Parallax Background Image -->
  <div class="hero-bg" style="background-image: url('/assets/images/hero_home.jpg');">
    <div class="hero-overlay"></div>
  </div>

  <div class="container-wide hero-container">
    <div class="hero-content">

      <!-- Architectural Tagline Badge -->
      <div class="badge-gold animate-fade-in-up">
        <span class="dot"></span> YOUR VISION. OUR EXPERIENCE. A HOME BUILT WITH AMBITION.
      </div>

      <!-- Main Headline -->
      <h1 class="hero-title animate-fade-in-up">
        CUSTOM HOMES.<br>
        <span class="text-gold-gradient">BUILT AROUND YOU.</span>
      </h1>

      <!-- Subtitle Description -->
      <p class="hero-subtitle animate-fade-in-up">
        From custom new homes and knock-down rebuilds to duplex designs, Ambition Built delivers carefully considered homes
        across Sydney with a commitment to quality, transparency and personalised service.
      </p>

      <!-- Action CTA Group -->
      <div class="hero-actions animate-fade-in-up">
        <button (click)="openConsultation()" class="btn-gold">
          START YOUR PROJECT
        </button>
        <a href="#projects" class="btn-outline-white">
          VIEW OUR PROJECTS
        </a>
      </div>

      <!-- Sub Services Bar -->
      <div class="hero-subbar animate-fade-in-up">
        <span>Custom Homes</span>
        <span class="divider">|</span>
        <span>Knock Down & Rebuild</span>
        <span class="divider">|</span>
        <span>Duplex Designs</span>
      </div>

    </div>
  </div>

  <!-- Scroll Down Indicator -->
  <a href="#stats" class="scroll-indicator" aria-label="Scroll Down">
    <div class="mouse">
      <div class="wheel"></div>
    </div>
  </a>
</section>